<template>
    <section
        class="gallery"
        :style="{...generateStylingVariables(content.style)}"
    >
        <div class="gallery__inner">
            <zoe-atom-text
                v-if="stringIsNotEmpty(content.text.value)"
                class="gallery__text"
                :item="content.text.value"
            />

            <div class="gallery__content">
                <div class="gallery__gallery">
                    <div
                        v-for="(item, index) in content.items"
                        :key="index"
                        class="gallery__preview-wrapper"
                        :class="{
                            'gallery__preview-wrapper--active': currentItem === index,
                        }"
                        @click="currentItem = index"
                    >
                        <div class="gallery__preview-overlay" />

                        <zoe-atom-media
                            class="gallery__preview"
                            :item="item.media.value"
                        />
                    </div>
                </div>

                <div class="gallery__items">
                    <div
                        v-for="(item, index) in content.items"
                        :key="index"
                        class="gallery__item-wrapper"
                        :class="{
                            'gallery__item-wrapper--active': currentItem === index,
                        }"
                    >
                        <zoe-atom-media
                            class="gallery__item"
                            :item="item.media.value"
                        />
                    </div>
                </div>
            </div>

            <button
                v-if="stringIsNotEmpty(content.button.value)"
                class="button"
                @click="buttonClick"
            >
                <zoe-atom-text
                    class="label"
                    :item="content.button.value"
                />
            </button>
        </div>
    </section>
</template>

<script>
import ZoeAtomText from '../../../../../../resources/components/atoms/text/v1.0.0/zoe-atom-text.vue';
import ZoeAtomMedia from '../../../../../../resources/components/atoms/media/v1.0.0/zoe-atom-media.vue';
import Component from '../../../../../../resources/mixins/component/component.vue';
import scrollToSelector from '../../../../../../resources/mixins/utils/scroll-to-selector';
import { generateStylingVariables } from '../../../../../../resources/mixins/styling/styling';

export default {
    components: {
        ZoeAtomText,
        ZoeAtomMedia
    },

    mixins: [ Component ],

    data() {
        return {
            currentItem: 0,
        };
    },

    methods: {
        generateStylingVariables,
        buttonClick() {
            const scrollOffset = this.getValue('general.logobar.position') === 'fixed' ? -160 : -60;

            scrollToSelector('.step__flow', scrollOffset);
        },
    },
};
</script>

<style lang="scss" scoped>
@use 'step-gallery';

.gallery {
    --border-color: v-bind('content.style.borderColor.value');
    --overlay-color: v-bind('content.style.overlayColor.value');
}
</style>
